import { computed, ref, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-03e2e82c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  key: 1
};
const _hoisted_3 = {
  key: 2
};
const _hoisted_4 = {
  key: 3
};
const _hoisted_5 = {
  key: 4
};
const _hoisted_6 = {
  key: 5
};
import { getQuery, postSave, postEdit, getSysconfig } from '@/api/payManage/accountManage';
import { OK, reportEvent } from '@/common';
import { message } from 'ant-design-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddOrEditModal',
  props: {
    modalVisible: {
      type: Boolean
    },
    editItem: null,
    PayChannelList: null,
    EntityList: null
  },
  emits: ['update:modalVisible', 'refresh', 'clearEditItem'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const isEdit = computed(() => {
      var _props$editItem;
      return !!((_props$editItem = props.editItem) !== null && _props$editItem !== void 0 && _props$editItem.id);
    });
    const filterOption = (input, option) => {
      return option.typeName.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };
    const visible = ref(false),
      accountForm = ref(),
      formValue = ref({
        id: undefined,
        accountId: undefined,
        mchName: undefined,
        payChannel: undefined,
        merchants: undefined,
        apiKeyV2: undefined,
        apiKeyV3: undefined,
        publicKey: undefined,
        clientId: undefined,
        clientSecret: undefined,
        settlementCurrency: undefined,
        cpId: undefined,
        wxPriKey: undefined,
        certSerialNo: undefined,
        valueAddedTaxRateId: undefined
      }),
      douyinRateList = ref([]);
    // formRules = ref({
    //       mchName:[{ required: true, message: "请选择主体/账号", trigger: "change" },],
    //       payChannel:[{ required: true, message: "请选择支付渠道", trigger: "change" },],
    //       "wxPayBaseConfig.merchants": [{ required: true, message: "请输入微信商户号", trigger: "blur" },],
    //       "wxPayBaseConfig.apiKey2": [{ required: true, message: "请输入API Key V2", trigger: "blur" },],
    //       "wxPayBaseConfig.apiKey3": [{ required: true, message: "请输入API Key V3", trigger: "blur" },],
    //       "aliPayBaseConfig.publicKey": [{ required: true, message: "请输入微信商户号", trigger: "blur" },],
    //     });
    const changeParams = Obj => {
      var _queryObj$wxPriKey;
      let queryObj = JSON.parse(JSON.stringify(Obj));
      let params = {
        accountId: undefined,
        id: queryObj === null || queryObj === void 0 ? void 0 : queryObj.id,
        mchName: queryObj.mchName,
        payChannel: queryObj.payChannel,
        wxPayBaseConfig: {
          merchants: queryObj.merchants,
          apiKeyV2: queryObj.apiKeyV2,
          apiKeyV3: queryObj.apiKeyV3,
          // 去除换行
          wxPriKey: (_queryObj$wxPriKey = queryObj.wxPriKey) === null || _queryObj$wxPriKey === void 0 ? void 0 : _queryObj$wxPriKey.replace(/[\r\n]/g, ''),
          certSerialNo: queryObj.certSerialNo
        },
        douyinPayBaseConfig: {
          valueAddedTaxRateId: queryObj.valueAddedTaxRateId
        },
        huawei: {
          clientId: queryObj.clientId,
          clientSecret: queryObj.clientSecret,
          issuerId: queryObj.issuerId,
          secretId: queryObj.secretId,
          serverSecret: queryObj.serverSecret
        },
        vivo: {
          cpId: queryObj.cpId
        },
        kuaishou: {},
        oppo: {},
        xiaomi: {}
      };
      if (queryObj.payChannel === 'amazon') {
        params = {
          ...params,
          amazon: {
            publicKey: queryObj.publicKey,
            clientId: queryObj.clientId,
            clientSecret: queryObj.clientSecret,
            settlementCurrency: queryObj.settlementCurrency
          },
          aliPayBaseConfig: {}
        };
      } else {
        params = {
          ...params,
          aliPayBaseConfig: {
            publicKey: queryObj.publicKey
          },
          amazon: {}
        };
      }
      if (queryObj.id) {
        params.accountId = queryObj.accountId;
      } else {
        var _props$EntityList$fin;
        params.accountId = (_props$EntityList$fin = props.EntityList.find(item => item.typeName == params.mchName)) === null || _props$EntityList$fin === void 0 ? void 0 : _props$EntityList$fin.accountId;
      }
      return params;
    };
    const changeform = async (queryObj = {}) => {
      let params = changeParams(queryObj);
      try {
        var _props$editItem2;
        const {
          code,
          msg
        } = (_props$editItem2 = props.editItem) !== null && _props$editItem2 !== void 0 && _props$editItem2.id ? await postEdit(params) : await postSave(params);
        if (code === OK) {
          var _props$editItem3;
          message.success(msg);
          emit('update:modalVisible', false);
          emit('refresh');
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: '主体管理',
              element_name: (_props$editItem3 = props.editItem) !== null && _props$editItem3 !== void 0 && _props$editItem3.id ? '编辑' : '新建'
            }
          });
        }
      } catch (e) {}
    };
    const query = async obj => {
      let params = {
        id: obj.id,
        payChannel: obj.payChannel
      };
      try {
        const {
          code,
          data
        } = await getQuery(params);
        if (code === OK) {
          var _data$wxPayBaseConfig, _data$wxPayBaseConfig2, _data$wxPayBaseConfig3, _data$wxPayBaseConfig4, _data$wxPayBaseConfig5, _data$aliPayBaseConfi, _data$douyinPayBaseCo, _data$huawei, _data$huawei2, _data$huawei3, _data$huawei4, _data$huawei5, _data$vivo;
          formValue.value = {
            id: data.id,
            accountId: data.accountId,
            mchName: data.mchName,
            payChannel: data.payChannel,
            merchants: (_data$wxPayBaseConfig = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig === void 0 ? void 0 : _data$wxPayBaseConfig.merchants,
            apiKeyV2: (_data$wxPayBaseConfig2 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig2 === void 0 ? void 0 : _data$wxPayBaseConfig2.apiKeyV2,
            apiKeyV3: (_data$wxPayBaseConfig3 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig3 === void 0 ? void 0 : _data$wxPayBaseConfig3.apiKeyV3,
            wxPriKey: (_data$wxPayBaseConfig4 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig4 === void 0 ? void 0 : _data$wxPayBaseConfig4.wxPriKey,
            certSerialNo: (_data$wxPayBaseConfig5 = data.wxPayBaseConfig) === null || _data$wxPayBaseConfig5 === void 0 ? void 0 : _data$wxPayBaseConfig5.certSerialNo,
            publicKey: (_data$aliPayBaseConfi = data.aliPayBaseConfig) === null || _data$aliPayBaseConfi === void 0 ? void 0 : _data$aliPayBaseConfi.publicKey,
            valueAddedTaxRateId: (_data$douyinPayBaseCo = data.douyinPayBaseConfig) === null || _data$douyinPayBaseCo === void 0 ? void 0 : _data$douyinPayBaseCo.valueAddedTaxRateId,
            clientId: (_data$huawei = data.huawei) === null || _data$huawei === void 0 ? void 0 : _data$huawei.clientId,
            clientSecret: (_data$huawei2 = data.huawei) === null || _data$huawei2 === void 0 ? void 0 : _data$huawei2.clientSecret,
            issuerId: (_data$huawei3 = data.huawei) === null || _data$huawei3 === void 0 ? void 0 : _data$huawei3.issuerId,
            secretId: (_data$huawei4 = data.huawei) === null || _data$huawei4 === void 0 ? void 0 : _data$huawei4.secretId,
            serverSecret: (_data$huawei5 = data.huawei) === null || _data$huawei5 === void 0 ? void 0 : _data$huawei5.serverSecret,
            cpId: (_data$vivo = data.vivo) === null || _data$vivo === void 0 ? void 0 : _data$vivo.cpId
          };
          if (data.payChannel === 'amazon') {
            var _data$amazon, _data$amazon2, _data$amazon3, _data$amazon4;
            formValue.value.publicKey = (_data$amazon = data.amazon) === null || _data$amazon === void 0 ? void 0 : _data$amazon.publicKey;
            formValue.value.clientId = (_data$amazon2 = data.amazon) === null || _data$amazon2 === void 0 ? void 0 : _data$amazon2.clientId;
            formValue.value.clientSecret = (_data$amazon3 = data.amazon) === null || _data$amazon3 === void 0 ? void 0 : _data$amazon3.clientSecret;
            formValue.value.settlementCurrency = (_data$amazon4 = data.amazon) === null || _data$amazon4 === void 0 ? void 0 : _data$amazon4.settlementCurrency;
          }
        }
      } catch (e) {}
    };
    const restore = () => {
      formValue.value = {
        id: undefined,
        accountId: undefined,
        mchName: undefined,
        payChannel: undefined,
        merchants: undefined,
        apiKeyV2: undefined,
        apiKeyV3: undefined,
        publicKey: undefined,
        clientId: undefined,
        clientSecret: undefined,
        settlementCurrency: undefined,
        wxPriKey: undefined,
        certSerialNo: undefined,
        valueAddedTaxRateId: undefined
      };
    };
    const closeModal = () => {
      var _accountForm$value;
      (_accountForm$value = accountForm.value) === null || _accountForm$value === void 0 || _accountForm$value.clearValidate();
      emit('clearEditItem', {});
      emit('update:modalVisible', false);
    };
    const handleOk = () => {
      var _accountForm$value2;
      (_accountForm$value2 = accountForm.value) === null || _accountForm$value2 === void 0 || _accountForm$value2.validate().then(() => {
        changeform(formValue.value);
      }).catch(error => {});
    };
    const getDouyinRateList = async () => {
      try {
        const {
          data,
          code
        } = await getSysconfig();
        if (code === OK) {
          douyinRateList.value = data.map(item => {
            return {
              ...item,
              value: item.id
            };
          });
        }
      } catch (e) {}
    };
    watch(() => props.modalVisible, val => {
      visible.value = val;
      val && getDouyinRateList();
    }, {
      immediate: true
    });
    watch(() => props.editItem, async newValue => {
      if (newValue.id) {
        //编辑
        await query(newValue);
      } else {
        // 新增
        restore();
      }
    }, {
      deep: true
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_textarea = _resolveComponent("a-textarea");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_modal = _resolveComponent("a-modal");
      const _directive_no_spaceAline = _resolveDirective("no-spaceAline");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: visible.value,
        "onUpdate:open": _cache[19] || (_cache[19] = $event => visible.value = $event),
        title: _unref(isEdit) ? '编辑主体信息' : '新建主体信息',
        width: "444px",
        "ok-text": "提交",
        onOk: handleOk,
        onCancel: closeModal,
        centered: "",
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form, {
          name: "accountForm",
          model: formValue.value,
          ref_key: "accountForm",
          ref: accountForm
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "主体",
            name: "mchName",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              allowClear: "",
              value: formValue.value.mchName,
              "onUpdate:value": _cache[0] || (_cache[0] = $event => formValue.value.mchName = $event),
              placeholder: "主体",
              options: props.EntityList,
              "field-names": {
                label: 'typeName',
                value: 'typeName'
              },
              disabled: _unref(isEdit),
              "filter-option": filterOption,
              "show-search": ""
            }, null, 8, ["value", "options", "disabled"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "支付渠道",
            name: "payChannel",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              allowClear: "",
              value: formValue.value.payChannel,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formValue.value.payChannel = $event),
              placeholder: "支付渠道",
              options: props.PayChannelList,
              "field-names": {
                label: 'typeName',
                value: 'type'
              },
              disabled: _unref(isEdit),
              "filter-option": filterOption,
              "show-search": ""
            }, null, 8, ["value", "options", "disabled"])]),
            _: 1
          }), formValue.value.payChannel === 'wxPayBaseConfig' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form_item, {
            label: "微信商户号",
            name: "merchants",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.merchants,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formValue.value.merchants = $event),
              valueModifiers: {
                lazy: true,
                number: true
              },
              maxlength: 10,
              placeholder: "请输入微信商户号"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "API Key V2",
            name: "apiKeyV2",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.apiKeyV2,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formValue.value.apiKeyV2 = $event),
              placeholder: "请输入API Key V2"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "API Key V3",
            name: "apiKeyV3",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.apiKeyV3,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => formValue.value.apiKeyV3 = $event),
              placeholder: "请输入API Key V3"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "微信私钥",
            name: "wxPriKey",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_textarea, {
              value: formValue.value.wxPriKey,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => formValue.value.wxPriKey = $event),
              placeholder: "请输入微信私钥"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "商户证书序列号",
            name: "certSerialNo",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.certSerialNo,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => formValue.value.certSerialNo = $event),
              placeholder: "请输入商户证书序列号"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          })])) : _createCommentVNode("", true), formValue.value.payChannel === 'aliPayBaseConfig' ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_a_form_item, {
            label: "支付宝公钥",
            name: "publicKey",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_textarea, {
              value: formValue.value.publicKey,
              "onUpdate:value": _cache[7] || (_cache[7] = $event => formValue.value.publicKey = $event),
              placeholder: "请输入支付宝公钥"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          })])) : _createCommentVNode("", true), formValue.value.payChannel === 'douyinPayBaseConfig' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_form_item, {
            label: "增值税税率",
            name: "valueAddedTaxRateId",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              placeholder: "请选择增值税税率",
              value: formValue.value.valueAddedTaxRateId,
              "onUpdate:value": _cache[8] || (_cache[8] = $event => formValue.value.valueAddedTaxRateId = $event),
              options: douyinRateList.value
            }, null, 8, ["value", "options"])]),
            _: 1
          })])) : _createCommentVNode("", true), formValue.value.payChannel === 'huawei' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_form_item, {
            label: "客户端 ID",
            name: "clientId",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.clientId,
              "onUpdate:value": _cache[9] || (_cache[9] = $event => formValue.value.clientId = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "API 密钥",
            name: "clientSecret",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.clientSecret,
              "onUpdate:value": _cache[10] || (_cache[10] = $event => formValue.value.clientSecret = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "Issuer ID",
            name: "issuerId"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.issuerId,
              "onUpdate:value": _cache[11] || (_cache[11] = $event => formValue.value.issuerId = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "密钥ID",
            name: "secretId"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.secretId,
              "onUpdate:value": _cache[12] || (_cache[12] = $event => formValue.value.secretId = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "服务端密钥",
            name: "serverSecret"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.serverSecret,
              "onUpdate:value": _cache[13] || (_cache[13] = $event => formValue.value.serverSecret = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          })])) : _createCommentVNode("", true), formValue.value.payChannel === 'amazon' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_a_form_item, {
            label: "共享密钥",
            name: "publicKey",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.publicKey,
              "onUpdate:value": _cache[14] || (_cache[14] = $event => formValue.value.publicKey = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "客户端ID",
            name: "clientId"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.clientId,
              "onUpdate:value": _cache[15] || (_cache[15] = $event => formValue.value.clientId = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "客户端密钥",
            name: "clientSecret"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.clientSecret,
              "onUpdate:value": _cache[16] || (_cache[16] = $event => formValue.value.clientSecret = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "结算货币",
            name: "settlementCurrency"
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.settlementCurrency,
              "onUpdate:value": _cache[17] || (_cache[17] = $event => formValue.value.settlementCurrency = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          })])) : _createCommentVNode("", true), formValue.value.payChannel === 'vivo' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_a_form_item, {
            label: "CPID",
            name: "cpId",
            required: ""
          }, {
            default: _withCtx(() => [_withDirectives(_createVNode(_component_a_input, {
              value: formValue.value.cpId,
              "onUpdate:value": _cache[18] || (_cache[18] = $event => formValue.value.cpId = $event),
              placeholder: "请输入"
            }, null, 8, ["value"]), [[_directive_no_spaceAline]])]),
            _: 1
          })])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }, 8, ["open", "title"]);
    };
  }
});